import { useCallback, useRef } from 'react'

export function useRefMap<Id extends string>() {
  const refMap = useRef<Record<Id, HTMLElement | null>>(
    {} as Record<Id, HTMLElement | null>,
  )

  const setRef = useCallback((id: Id) => {
    return (el: HTMLElement | null) => {
      refMap.current[id] = el
    }
  }, [])

  return { refMap: refMap.current, setRef }
}
